<!-- 彩票投注站申请 -->
<template>
    <!-- 不绑定 v-loading：上传时的 loading 由 UploadCard 各自承担，不遮罩整个页面 -->
    <div class="biaodan">

        <el-form :model="form" :rules="rules" ref="form" label-width="160px">

            <el-form-item label="用户名/昵称:" prop="nickname">
                <el-input type="text" v-model="form.nickname" />
            </el-form-item>

            <el-form-item label="手机:" prop="phoneNumber">
                <el-input type="text" v-model="form.phoneNumber" maxlength="11" />
            </el-form-item>

            <el-form-item label="真实姓名:" prop="identityCardName">
                <div style="display:flex;align-items:center;">
                    <el-input type="text" v-model="form.identityCardName" style="width:200px;marginRight:20px" />
                    <span class="msg">一旦实名认证将不能修改，并且要和提现银行卡/微信/支付宝的姓名一致</span>
                </div>
            </el-form-item>

            <el-form-item label="身份证号:" prop="identityCardNo">
                <div style="display:flex;align-items:center;">
                    <el-input type="text" :maxlength="18" v-model="form.identityCardNo"
                        style="width:200px;marginRight:20px" />
                    <span class="msg">一旦实名认证将不能修改</span>
                </div>
            </el-form-item>

            <el-form-item label="入驻彩种:" prop="lotteryTypes">
                <el-select v-model="form.lotteryTypes" placeholder="请选择" style="width: 220px;">
                    <el-option v-for="item in select.arr" :key="item.roleId" :label="item.roleName"
                        :value="item.roleId">
                    </el-option>
                </el-select>
                <span class="msg" style="margin-left:10px;">单选（双色球、大乐透）</span>
            </el-form-item>

            <!-- 投注站入驻个人说明 -->
            <el-form-item label-width="0">
                <textarea-block v-model="form.shopPersonalDescription" title="投注站入驻个人说明"
                    placeholder="请简单介绍一下您的投注站情况、经营年限、擅长彩种等" :maxlength="500" :rows="4" />
            </el-form-item>

            <!-- 身份证上传：正面 + 反面 并排 -->
            <el-form-item label="身份证上传:" required>
                <div class="upload-row">
                    <upload-card :preview="showImg.identityCardFront" title="身份证正面" tip="支持JPG、PNG格式" :width="150"
                        :height="170" :loading="uploadingField === 'identityCardFront'"
                        @change="e => chooseImg(e, 'identityCardFront')" @remove="removeImg('identityCardFront')" />

                    <upload-card :preview="showImg.identityCardBack" title="身份证反面" tip="支持JPG、PNG格式" :width="150"
                        :height="170" :loading="uploadingField === 'identityCardBack'"
                        @change="e => chooseImg(e, 'identityCardBack')" @remove="removeImg('identityCardBack')" />
                </div>
            </el-form-item>

            <!-- 头像上传（可选） -->
            <el-form-item label="头像上传:">
                <upload-card :preview="showImg.avatar" title="头像" tip="支持JPG、PNG格式" :width="150" :height="170"
                    :loading="uploadingField === 'avatar'" @change="e => chooseImg(e, 'avatar')"
                    @remove="removeImg('avatar')" />
            </el-form-item>

            <!-- 无犯罪记录证明 -->
            <el-form-item label="无犯罪记录证明上传:" required>
                <div class="upload-row">
                    <upload-card :preview="showImg.noCrimeCertificate" title="无犯罪记录证明" tip="到本地派出所开具" :width="150"
                        :height="170" :loading="uploadingField === 'noCrimeCertificate'"
                        @change="e => chooseImg(e, 'noCrimeCertificate')" @remove="removeImg('noCrimeCertificate')" />

                    <div class="upload-side-tip">
                        <p><i class="el-icon-info"></i> 支持 JPG、PNG 格式</p>
                        <p><i class="el-icon-location"></i> 到本地派出所开具无犯罪记录证明</p>
                    </div>
                </div>
            </el-form-item>

            <el-form-item label="是否有60人以上彩票QQ群、微信群前：" prop="groupChat">
                <el-input v-model="form.groupChat" type="text" placeholder="如果没有填无，如果有，说明QQ群号、微信号" />
            </el-form-item>

            <el-form-item label="投注站地址：" prop="bettingShop">
                <el-input v-model="form.bettingShop" type="text" placeholder="请明投注站详细信息" />
            </el-form-item>

            <el-form-item label="投注站编号：" prop="bettingShopNumber">
                <el-input v-model="form.bettingShopNumber" type="text" />
            </el-form-item>

            <el-form-item label="希望平台给予哪些帮扶：" prop="neededAssist">
                <el-input v-model="form.neededAssist" type="text" />
            </el-form-item>

            <el-form-item label="QQ号：" prop="qqNumber">
                <el-input type="text" v-model="form.qqNumber" style="width:200px;" />
                <span style="margin-left:40px;">微信号：</span>
                <el-input type="text" v-model="form.wechatNumber" style="width:200px;" />
            </el-form-item>

            <el-form-item label="钉钉号：" prop="dingTalkNumber">
                <el-input type="text" v-model="form.dingTalkNumber" style="width:300px;" />
                <span style="margin-left:30px;">性别：</span>
                <el-radio-group v-model="form.gender">
                    <el-radio label="0">男</el-radio>
                    <el-radio label="1">女</el-radio>
                    <el-radio label="2">保密</el-radio>
                </el-radio-group>
            </el-form-item>

            <!-- 投注站的相关证照：4张并排 -->
            <el-form-item label="投注站的相关证照：" required>
                <div class="upload-row">
                    <upload-card small :preview="showImg.bettingShopLicense" title="营业执照" :width="124" :height="140"
                        :loading="uploadingField === 'bettingShopLicense'"
                        @change="e => chooseImg(e, 'bettingShopLicense')" @remove="removeImg('bettingShopLicense')" />

                    <upload-card small :preview="showImg.holdingLicense" title="手持营业执照" :width="124" :height="140"
                        :loading="uploadingField === 'holdingLicense'" @change="e => chooseImg(e, 'holdingLicense')"
                        @remove="removeImg('holdingLicense')" />

                    <upload-card small :preview="showImg.bettingShopFacadePhoto" title="投注站门面照" :width="124"
                        :height="140" :loading="uploadingField === 'bettingShopFacadePhoto'"
                        @change="e => chooseImg(e, 'bettingShopFacadePhoto')"
                        @remove="removeImg('bettingShopFacadePhoto')" />

                    <upload-card small :preview="showImg.bettingShopIndoorPhoto" title="投注站室内照" :width="124"
                        :height="140" :loading="uploadingField === 'bettingShopIndoorPhoto'"
                        @change="e => chooseImg(e, 'bettingShopIndoorPhoto')"
                        @remove="removeImg('bettingShopIndoorPhoto')" />
                </div>
            </el-form-item>

            <el-form-item label="投注站站长彩票宣言：" prop="shopDeclaration">
                <el-input type="text" placeholder="用一句话概括" v-model="form.shopDeclaration" flex="1" />
            </el-form-item>

            <el-form-item label="">
                <el-button type="primary" @click="submit" :loading="saveBtnLoading">确认</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
import { representative_role_list, bettingShopApply } from '@/api/apply'
import baseApply from './baseApply.js'
import UploadCard from './UploadCard.vue'
import TextareaBlock from './TextareaBlock.vue'

export default {
    name: 'ShopApply',
    components: { UploadCard, TextareaBlock },
    mixins: [baseApply],
    methods: {
        // 入驻彩种选项来源：投注站帮扶专用列表
        roleApi() {
            return representative_role_list({ type: 'BETTING_SHOP_ASSIST' })
        },
        // 直接用接口返回数据，不再额外过滤
        filterRoleList(list) {
            return list || []
        },
        // 提交：彩票投注站帮扶申请
        submitApi(data) {
            return bettingShopApply(data)
        },

        // ============ 测试数据（仅本地调试用，上线前删除） ============
        fillTestData() {
            Object.assign(this.form, {
                nickname: '测试投注站站长-何新乐',
                phoneNumber: '13131133771',
                identityCardName: '何新乐',
                identityCardNo: '13012119950604181X',
                groupChat: '有，QQ群号：123456789；微信群：test_wx_001',
                bettingShop: '河北省石家庄市长安区建设北大街88号',
                bettingShopNumber: 'BJ20260001',
                neededAssist: '希望平台给予投注站流量扶持与软件定制帮扶',
                qqNumber: '123456789',
                wechatNumber: 'test_wx_001',
                dingTalkNumber: 'dingtalk_001',
                gender: '0',
                shopPersonalDescription: '经营体彩投注站8年，擅长双色球与大乐透，固定彩民60余人',
                shopDeclaration: '诚信经营，用心服务每一位彩民',
            })
        },
        // =============================================================
    },
    mounted() {
        // 等待 mixin 的 mounted（加载角色列表）执行完后再填测试数据
        this.$nextTick(() => {
            setTimeout(() => this.fillTestData(), 300)
        })
    }
};
</script>

<style lang="scss" scoped>
.upload-row {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 16px;
}

.upload-side-tip {
    color: #8a97a8;
    font-size: 13px;
    line-height: 1.9;

    p {
        margin: 0;
        display: flex;
        align-items: center;
        gap: 6px;
    }

    i {
        color: #5aa9ff;
        font-size: 14px;
    }
}
</style>
